import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'pluralizeUnit',
})
export class PluralizeUnitPipe implements PipeTransform {
	transform(value: number, unit: string): string {
		if (value > 1) {
			return unit;
		} else {
			return unit.toLowerCase().endsWith('s') ? unit.slice(0, -1) : unit;
		}
	}
}
